import React, { useState, useEffect, useCallback } from 'react';
import useDevice from '../../../hooks/useDevice.mjs';
import ArrowLeft from '../../Basic/Icons/ArrowLeft.mjs';
import ArrowRight from '../../Basic/Icons/ArrowRight.mjs';
import { StyledCarouselContainer, StyledCarouselPrevButton, StyledCarouselButtonIconContainer, StyledCarouselViewport, StyledCarousel, StyledPadding, StyledCarouselNextButton } from './HorizontalCarousel.styles.mjs';
import useEmblaCarousel from 'embla-carousel-react';

const emblaCarouselDefaultOptions = {
    dragFree: true
};
const HorizontalCarousel = ({ children, className, options, showArrows = true, hideSidesPadding = false, onInit }) => {
    const { isMobile } = useDevice();
    const [emblaRef, emblaApi] = useEmblaCarousel(Object.assign(Object.assign({}, emblaCarouselDefaultOptions), options));
    const [isPrevEnabled, setIsPrevEnabled] = useState(false);
    const [isNextEnabled, setIsNextEnabled] = useState(false);
    const handleEmblaSelectChange = () => {
        setIsPrevEnabled(emblaApi.canScrollPrev());
        setIsNextEnabled(emblaApi.canScrollNext());
    };
    useEffect(() => {
        if (emblaApi) {
            emblaApi.on('select', handleEmblaSelectChange);
            onInit && onInit(emblaApi);
            handleEmblaSelectChange();
        }
    }, [emblaApi]);
    useEffect(() => {
        if (emblaApi) {
            emblaApi.reInit(Object.assign(Object.assign({}, emblaCarouselDefaultOptions), options));
        }
    }, [emblaApi, options]);
    const handlePrevClick = useCallback(() => {
        emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
    }, [emblaApi]);
    const handleNextClick = useCallback(() => {
        emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
    }, [emblaApi]);
    return (React.createElement(StyledCarouselContainer, null,
        showArrows && isPrevEnabled && (React.createElement(StyledCarouselPrevButton, { onClick: handlePrevClick },
            React.createElement(StyledCarouselButtonIconContainer, null,
                React.createElement(ArrowLeft, null)))),
        React.createElement(StyledCarouselViewport, { className: className, ref: emblaRef },
            React.createElement(StyledCarousel, null,
                !hideSidesPadding && isMobile && React.createElement(StyledPadding, null),
                children,
                !hideSidesPadding && isMobile && React.createElement(StyledPadding, null))),
        showArrows && isNextEnabled && (React.createElement(StyledCarouselNextButton, { onClick: handleNextClick },
            React.createElement(StyledCarouselButtonIconContainer, null,
                React.createElement(ArrowRight, null))))));
};

export { HorizontalCarousel as default };
//# sourceMappingURL=HorizontalCarousel.mjs.map
